import {
  subscribeGovernorLiveActions,
  getGovernorLiveActions,
} from "@/lib/governorEventBus";

export interface GovernorCommandCenterSnapshot {
  actions: any[];
  lastUpdated: string;
}

let snapshot: GovernorCommandCenterSnapshot = {
  actions: getGovernorLiveActions(),
  lastUpdated: new Date().toISOString(),
};

export function getGovernorCommandCenterSnapshot() {
  return snapshot;
}

export function startGovernorCommandCenterLiveBridge(
  onUpdate?: (snapshot: GovernorCommandCenterSnapshot) => void
) {
  return subscribeGovernorLiveActions((actions) => {
    snapshot = {
      actions,
      lastUpdated: new Date().toISOString(),
    };

    onUpdate?.(snapshot);
  });
}

export const GOVERNOR_COMMAND_CENTER_LIVE_BRIDGE_READY = true;
